/** Cached client IP — set once on app load via /api/client-info */
let clientIp = '';

export function setClientIp(ip: string) {
  clientIp = ip;
}

/** Read a browser cookie by name. Returns '' if not found. */
export function getCookie(name: string): string {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : '';
}

/** Collect IP, UserAgent, Facebook, Google Ads and Google Analytics data. */
export function getTrackingCookies() {
  const params = new URLSearchParams(window.location.search);
  return {
    ip: clientIp,
    user_agent: navigator.userAgent,
    // Facebook pixel
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc') || params.get('fbclid') || '',
    // Google Analytics
    ga: getCookie('_ga'),
    gid: getCookie('_gid'),
    // Google Ads
    gcl_au: getCookie('_gcl_au'),
    gclid: params.get('gclid') || getCookie('_gcl_gcs') || '',
  };
}

/** Push an event to window.dataLayer (GTM). */
export function pushDataLayer(event: string, data: Record<string, unknown>) {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({ event, ...data });
}
